import { ActionCreator } from 'redux';
import { ApplicationState } from '..';
import {
    DashboardProduct,
    ProductActionTypes,
    ProductGetListStart,
    ProductGetListSuccess,
    ProductGetListError,
    ProductListState,
    LoadBillingPlans,
    LoadingBillingPlansError,
    BillingPlansLoaded,
} from './types';
import { BillingPlan, ProductCode } from '@dev/ee-api/ee-api-models';

export const LoadProductList: ActionCreator<ProductGetListStart> = (): ProductGetListStart => ({
    type: ProductActionTypes.LOAD_PRODUCT_LIST,
});

export const ProductListLoaded: ActionCreator<ProductGetListSuccess> = (
    dashboards: DashboardProduct[]
): ProductGetListSuccess => ({
    type: ProductActionTypes.LOAD_PRODUCT_LIST_SUCCESS,
    payload: {
        dashboards,
    },
});

export const PlansLoaded = (billingPlans: BillingPlan[]): BillingPlansLoaded => ({
    type: ProductActionTypes.BILLING_PLANS_LOADED,
    payload: {
        billingPlans,
    },
});

export const ProductListLoadingError: ActionCreator<ProductGetListError> = (): ProductGetListError => ({
    type: ProductActionTypes.LOAD_PRODUCT_ERROR,
});

export const PlansLoadingError = (): LoadingBillingPlansError => ({
    type: ProductActionTypes.LOADING_BILLING_PLANS_ERROR,
});

export const GetBillingPlans = (billingPlanCode: ProductCode): LoadBillingPlans => ({
    type: ProductActionTypes.LOAD_BILLING_PLANS,
    payload: {
        billingPlanCode,
    },
});

export const getProductStore = (state: ApplicationState): ProductListState => state.products;
export const getBillingPlanList = (store: ApplicationState): BillingPlan[] => store.products?.billingPlans;
export const getDashboards = (store: ApplicationState): DashboardProduct[] => store.products?.dashboards;
